import { useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";
import CustomCode from '../../../Util/Code/CustomCode';
import RouteMap from '../../../Util/Map/RouteMap'

function ComponentExample() {

  const [activeTab, setActiveTab] = useState('component');

  const codeString = `
      // Exemplo de uso 
      <RouteMap
        pointA={{
          lat: -23.54304063036703,
          lng: -46.545861112470114,
          label: 'Aluno',
          address: 'Rua Coronel Marques, 371 - Vila Nova Manchester, São Paulo - SP',
          reference: 'aluno'
        }}
        pointB={{
          lat: -23.545771811605988,
          lng: -46.53970627802274,
          label: 'Escola',
          address: 'R. Lutécia, 186 - Vila Carrao, São Paulo - SP, 03423-000, Brazil',
          reference: 'escola'
        }}
        onChange={(e) => console.log(e)}
      />

      // Valor de Retorno no onChange
      {
        distance: 0.883,
        distance_mesure_unit: "km",
        duration: 3,
        duration_mesure_unit: "minutes",
        travelMode: "DRIVING"
      }
    };
`;

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "component" })}
            onClick={() => {
              setActiveTab("component");
            }}
          >
            Componente
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "codeBox" })}
            onClick={() => {
              setActiveTab("codeBox");
            }}
          >
            Código
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        <TabPane tabId="component">
          <Col sm="12">
            <div style={{ margin: 10 }}>
              <RouteMap
                pointA={{
                  lat: -23.54304063036703,
                  lng: -46.545861112470114,
                  label: 'Aluno',
                  address: 'Rua Coronel Marques, 371 - Vila Nova Manchester, São Paulo - SP',
                  reference: 'aluno'
                }}
                pointB={{
                  lat: -23.545771811605988,
                  lng: -46.53970627802274,
                  label: 'Escola',
                  address: 'R. Lutécia, 186 - Vila Carrao, São Paulo - SP, 03423-000, Brazil',
                  reference: 'escola'
                }}
                onChange={(e) => console.log(e)} />
            </div>
          </Col>
        </TabPane>
        <TabPane tabId="codeBox">
          <Col sm="12">
            <CustomCode codeString={codeString} archiveName={'RouteMap.js'} />
          </Col>
        </TabPane>
      </TabContent>
    </div>
  );
}

export default ComponentExample;